<template>
  <div id="app">
    <div id="scenewrap">
      <Aside />
      <Scene />
    </div>
    <Footer />
  </div>
</template>

<script>
import Scene from "../components/Scene";
import Footer from "../components/layout/Footer";
import Aside from "../components/layout/Aside";

export default {
  components: {
    Scene,
    Footer,
    Aside,
  },
};
</script>

<style lang="scss" scoped>
#scenewrap {
  display: flex;
  width: 100%;
  height: fit-content;
}
</style>
